import React, { useRef, useState } from "react";

import "./light-dark.css";

export default function Slider({ clickHandler }) {
  return (
    <div style={{ position: "absolute", right: 0, fontSize: "4px" }}>
      <head>
        <script src="https://code.iconify.design/1/1.0.4/iconify.min.js"></script>
      </head>
      <label>
        <input
          className="toggle-checkbox"
          type="checkbox"
          onClick={clickHandler}
        ></input>
        <div className="toggle-slot">
          <div className="sun-icon-wrapper">
            <div
              className="iconify sun-icon"
              data-icon="feather-sun"
              data-inline="false"
            ></div>
          </div>
          <div className="toggle-button"></div>
          <div className="moon-icon-wrapper">
            <div
              className="iconify moon-icon"
              data-icon="feather-moon"
              data-inline="false"
            ></div>
          </div>
        </div>
      </label>
    </div>
  );
}
